import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '~/literals';

import { ErrorResponse, ItineraryPackage, ItineraryPackagesState } from '~/types';

export const itineraryPackagesState: ItineraryPackagesState = {
  packages: [],
  alertMessage: '',
  pageStatus: STATUS.IDLE,
};

export const itineraryPackagesSlice = createSlice({
  name: 'itineraryPackages',
  initialState: itineraryPackagesState,
  reducers: {
    getItineraryPackages: (draft) => {
      draft.alertMessage = '';
      draft.pageStatus = STATUS.RUNNING;
    },
    getItineraryPackagesSuccess: (draft, { payload }: PayloadAction<ItineraryPackage[]>) => {
      draft.packages = payload;
      draft.pageStatus = STATUS.SUCCESS;
    },
    getItineraryPackagesFailure: (draft, { payload }: PayloadAction<ErrorResponse>) => {
      draft.alertMessage = payload.errorMessage || 'Could not load itinerary packages.';
      draft.pageStatus = STATUS.ERROR;
    },
  },
});

export const {
  getItineraryPackages,
  getItineraryPackagesSuccess,
  getItineraryPackagesFailure,
} = itineraryPackagesSlice.actions;

export default itineraryPackagesSlice.reducer;
